import { render } from "./ErrorLogin.vue?vue&type=template&id=12b6f7da&scoped=true"
import script from "./ErrorLogin.vue?vue&type=script&lang=js"
export * from "./ErrorLogin.vue?vue&type=script&lang=js"

import "./ErrorLogin.vue?vue&type=style&index=0&id=12b6f7da&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-12b6f7da"

export default script